export default __webpack_public_path__ + "static/media/EchoAR.d6566e4c.svg";